var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefereshPrompt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.61409 5.81801C3.32865 7.05971 3.36548 8.3722 3.71994 9.5895C4.0744 10.8068 4.73057 11.8742 5.60546 12.6568C6.48035 13.4394 7.53467 13.902 8.63509 13.9861C9.73552 14.0702 10.8326 13.772 11.7877 13.1292M14.3855 9.18199C14.6709 7.94029 14.6341 6.6278 14.2796 5.4105C13.9252 4.19321 13.269 3.12577 12.3941 2.34319C11.5192 1.5606 10.4649 1.09802 9.36449 1.01392C8.26406 0.929833 7.16696 1.22801 6.21191 1.87076",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 8.06469L3.42424 5.23877L5.84848 8.06469M12.1515 6.93432L14.5758 9.76025L17 6.93432",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefereshPrompt);
export default __webpack_public_path__ + "static/media/RefereshPrompt.a5c8e2151a5a190aaaf23b80328b2c8f.svg";
export { ForwardRef as ReactComponent };